type Props = {
    fill?: string;
    className?: string;
};

export const Arrow = ({ fill = '#30373C', className }: Props) => {
    return (
        <svg className={className} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.76599 4.09608C4.55997 4.26776 4.2607 4.26776 4.05468 4.09607L0.721393 1.31829C0.485685 1.12187 0.45384 0.771554 0.650267 0.535846C0.846693 0.300138 1.19701 0.268294 1.43272 0.46472L4.41034 2.94611L7.38807 0.464716C7.62378 0.268293 7.97409 0.300142 8.17052 0.535853C8.36694 0.771564 8.33509 1.12188 8.09938 1.3183L4.76599 4.09608Z"
                fill={fill}
            />
        </svg>
    );
};
